import { render, staticRenderFns } from "./ExhibitorFormFields.vue?vue&type=template&id=5581bfff"
import script from "./ExhibitorFormFields.vue?vue&type=script&lang=ts"
export * from "./ExhibitorFormFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports